import store from "@/store";

export default [
  {
    path: "/logout",
    redirect: "/signout",
  },
  {
    path: "/signout",
    beforeEnter: (to, from, next) => {
      store.dispatch("cognito/signOut").then(res => {
        // default behavior
        if (!res || !res.redirect_url) next("/signin");
        // when redirect_url absolute
        if (res.redirect_url.indexOf("http") == 0) window.location = res.redirect_url;
        // when redirect_url relative
        else next(res.redirect_url);
      });
    },
  },
];
